/*
* Pipeline Theme — custom.js
*
* Loaded with defer at the end of layout files.
* Consent: OneTrust Shopify app owns the banner + Shopify sync.
* snippets/onetrust-cookies.liquid bridges visitorConsentCollected → forall:consent:updated.
* Add marketing/analytics loaders in onConsentUpdated below.
*
*/

(function() {

  function onConsentUpdated(event) {
    var detail = event && event.detail ? event.detail : {};
    if (!detail.trackingAllowed) {
      return;
    }
    // Load marketing/analytics tools here only after consent is granted.
    // detail.analyticsAllowed / detail.marketingAllowed are available for granular gating.
  }

  document.addEventListener('foreall:consent:updated', onConsentUpdated);

  if (window.__foreallConsentPending) {
    onConsentUpdated();
  }

  // Pipeline example listeners removed — they logged every theme:scroll / theme:resize
  // to the console. Re-add handlers here only when you need custom behavior.

  // Theme editor: keep the mobile drawer open across header section reloads.
  var EDITOR_DRAWER_KEY = 'foreall:editor:mobile-drawer';
  var EDITOR_DROPDOWN_KEY = 'foreall:editor:desktop-dropdown';
  var pinnedDesktopDropdownId = null;
  var desktopDropdownObserver = null;

  function isDesignMode() {
    return window.Shopify && window.Shopify.designMode;
  }

  function getHeaderSectionRoot(sectionEventTarget) {
    if (!sectionEventTarget) return null;
    return sectionEventTarget.querySelector('[data-section-type="header"]');
  }

  function getHeaderRoot() {
    return document.querySelector('[data-section-type="header"]');
  }

  function isMobileHeaderActive() {
    var mobileHeader = document.querySelector('.header__mobile');
    if (!mobileHeader) return false;
    return window.getComputedStyle(mobileHeader).display !== 'none';
  }

  function isDesktopHeaderActive() {
    var desktopHeader = document.querySelector('[data-header-desktop]');
    if (!desktopHeader) return false;
    return window.getComputedStyle(desktopHeader).display !== 'none';
  }

  function syncEditorBlockTargets() {
    if (!isDesignMode()) return;

    var header = getHeaderRoot();
    if (!header) return;

    var mobileActive = isMobileHeaderActive();
    var mobileRoot = header.querySelector('.header__mobile');
    var desktopRoot = header.querySelector('[data-header-desktop]');

    [mobileRoot, desktopRoot].forEach(function(root) {
      if (!root) return;

      var isActive = root === mobileRoot ? mobileActive : !mobileActive;

      root.querySelectorAll('[id^="shopify-block-"], [data-foreall-editor-block-id]').forEach(function(el) {
        if (isActive) {
          if (el.dataset.forallEditorBlockId) {
            el.id = el.dataset.forallEditorBlockId;
            delete el.dataset.forallEditorBlockId;
          }
        } else if (el.id && el.id.indexOf('shopify-block-') === 0) {
          el.dataset.forallEditorBlockId = el.id;
          el.removeAttribute('id');
        }
      });
    });
  }

  function getDropdownIdForElement(el) {
    if (!el || !el.closest) return null;
    var disclosure = el.closest('[data-hover-disclosure]');
    return disclosure && disclosure.id ? disclosure.id : null;
  }

  function openDesktopDropdown(dropdownId) {
    if (!dropdownId) return null;

    var disclosure = document.getElementById(dropdownId);
    if (!disclosure || disclosure.closest('.header__mobile')) return null;

    var trigger = document.querySelector('[data-hover-disclosure-toggle="' + dropdownId + '"]');
    if (!trigger) return null;

    var wrapper = disclosure.closest('[data-header-wrapper]');
    if (wrapper && trigger.classList.contains('grandparent')) {
      wrapper.classList.add('meganav--visible');
    } else if (wrapper) {
      wrapper.classList.remove('meganav--visible');
    }

    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('is-visible');
    disclosure.classList.add('is-visible');

    return disclosure;
  }

  function saveDesktopDropdownState(dropdownId) {
    if (!dropdownId) return;

    pinnedDesktopDropdownId = dropdownId;
    sessionStorage.setItem(EDITOR_DROPDOWN_KEY, JSON.stringify({
      dropdownOpen: true,
      dropdownId: dropdownId
    }));
  }

  function clearDesktopDropdownState() {
    pinnedDesktopDropdownId = null;
    sessionStorage.removeItem(EDITOR_DROPDOWN_KEY);
  }

  function captureDesktopDropdownState() {
    var header = getHeaderRoot();
    if (!header) return null;

    var openDropdownId = null;
    header.querySelectorAll('[data-header-desktop] [data-hover-disclosure].is-visible').forEach(function(el) {
      if (el.id) {
        openDropdownId = el.id;
      }
    });

    if (!openDropdownId) return null;

    return {
      dropdownOpen: true,
      dropdownId: openDropdownId
    };
  }

  function restoreDesktopDropdownState() {
    var raw = sessionStorage.getItem(EDITOR_DROPDOWN_KEY);
    if (!raw) return;

    var state;
    try {
      state = JSON.parse(raw);
    } catch (error) {
      clearDesktopDropdownState();
      return;
    }

    if (!state || !state.dropdownOpen || !state.dropdownId) return;

    setTimeout(function() {
      syncEditorBlockTargets();
      openDesktopDropdown(state.dropdownId);
      pinnedDesktopDropdownId = state.dropdownId;
      watchPinnedDesktopDropdown();
    }, 120);
  }

  function watchPinnedDesktopDropdown() {
    if (!isDesignMode() || !pinnedDesktopDropdownId) return;

    var disclosure = document.getElementById(pinnedDesktopDropdownId);
    if (!disclosure) return;

    if (desktopDropdownObserver) {
      desktopDropdownObserver.disconnect();
    }

    desktopDropdownObserver = new MutationObserver(function() {
      if (!pinnedDesktopDropdownId || !isDesktopHeaderActive()) return;
      if (!disclosure.isConnected) return;
      if (!disclosure.classList.contains('is-visible')) {
        setTimeout(function() {
          openDesktopDropdown(pinnedDesktopDropdownId);
        }, 10);
      }
    });

    desktopDropdownObserver.observe(disclosure, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function revealHeaderBlockInDesktop(blockEl) {
    if (!blockEl) return;

    var dropdownId = getDropdownIdForElement(blockEl);
    if (!dropdownId) return;

    syncEditorBlockTargets();
    openDesktopDropdown(dropdownId);
    saveDesktopDropdownState(dropdownId);
    watchPinnedDesktopDropdown();

    if (blockEl.scrollIntoView) {
      blockEl.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }
  }

  function findHeaderBlockElement(event) {
    var blockEl = event.target;
    var blockId = event.detail && event.detail.blockId;

    if (blockEl && blockEl.closest && blockEl.closest('[data-section-type="header"]') && blockEl.id && blockEl.id.indexOf('shopify-block-') === 0) {
      return blockEl;
    }

    if (blockId) {
      syncEditorBlockTargets();
      blockEl = document.getElementById('shopify-block-' + blockId);
      if (blockEl) return blockEl;
    }

    return null;
  }

  function getSlideruleChainForElement(el) {
    var chain = [];
    var node = el;

    while (node) {
      if (node.id && node.matches && node.matches('[data-sliderule]')) {
        chain.unshift(node.id);
      }
      if (node.id === 'header-menu') {
        break;
      }
      node = node.parentElement;
    }

    return chain;
  }

  function openMobileDrawerChain(chain, scrollTop, onComplete) {
    var drawer = document.getElementById('header-menu');
    if (!drawer) return;

    if (!drawer.classList.contains('drawer--visible')) {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }

    chain = chain || [];
    var stepDelay = 250;
    var baseDelay = 120;

    chain.forEach(function(panelId, index) {
      setTimeout(function() {
        var panel = document.getElementById(panelId);
        if (panel && panel.classList.contains('is-visible')) {
          return;
        }

        var trigger = document.querySelector('[data-sliderule-open="' + panelId + '"]');
        if (trigger) {
          trigger.click();
        }
      }, baseDelay + index * stepDelay);
    });

    setTimeout(function() {
      var scrollEl = drawer.querySelector('[data-drawer-scrolls]');
      if (scrollEl && scrollTop) {
        scrollEl.scrollTop = scrollTop;
      }
      if (typeof onComplete === 'function') {
        onComplete(drawer, scrollEl);
      }
    }, baseDelay + chain.length * stepDelay + 100);
  }

  function captureMobileDrawerState() {
    var drawer = document.getElementById('header-menu');
    if (!drawer) return null;

    var drawerOpen = drawer.classList.contains('drawer--visible');
    var paneEl = drawer.querySelector('[data-sliderule-pane]');
    var sliderulePane = paneEl ? parseInt(paneEl.getAttribute('data-sliderule-pane'), 10) || 0 : 0;
    var openSlideruleChain = [];
    var scrollEl = drawer.querySelector('[data-drawer-scrolls]');

    drawer.querySelectorAll('[data-sliderule].is-visible').forEach(function(panel) {
      if (panel.id) {
        openSlideruleChain.push(panel.id);
      }
    });

    return {
      drawerOpen: drawerOpen,
      sliderulePane: sliderulePane,
      openSlideruleChain: openSlideruleChain,
      drawerScrollTop: scrollEl ? scrollEl.scrollTop : 0
    };
  }

  function restoreMobileDrawerState() {
    var raw = sessionStorage.getItem(EDITOR_DRAWER_KEY);
    if (!raw) return;

    var state;
    try {
      state = JSON.parse(raw);
    } catch (error) {
      sessionStorage.removeItem(EDITOR_DRAWER_KEY);
      return;
    }

    if (!state || !state.drawerOpen) return;

    openMobileDrawerChain(state.openSlideruleChain, state.drawerScrollTop);
  }

  function revealHeaderBlockInDrawer(blockEl) {
    if (!blockEl) return;

    var chain = getSlideruleChainForElement(blockEl);

    openMobileDrawerChain(chain, 0, function(drawer, scrollEl) {
      if (scrollEl) {
        var blockTop = blockEl.getBoundingClientRect().top - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop;
        scrollEl.scrollTop = Math.max(0, blockTop - 24);
      } else if (blockEl.scrollIntoView) {
        blockEl.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }

      sessionStorage.setItem(EDITOR_DRAWER_KEY, JSON.stringify({
        drawerOpen: true,
        openSlideruleChain: chain,
        drawerScrollTop: scrollEl ? scrollEl.scrollTop : 0
      }));
    });
  }

  document.addEventListener('shopify:section:unload', function(event) {
    if (!isDesignMode()) return;
    if (!getHeaderSectionRoot(event.target)) return;

    var drawerState = captureMobileDrawerState();
    if (drawerState && drawerState.drawerOpen) {
      sessionStorage.setItem(EDITOR_DRAWER_KEY, JSON.stringify(drawerState));
    } else {
      sessionStorage.removeItem(EDITOR_DRAWER_KEY);
    }

    var dropdownState = captureDesktopDropdownState();
    if (!dropdownState && pinnedDesktopDropdownId) {
      dropdownState = {
        dropdownOpen: true,
        dropdownId: pinnedDesktopDropdownId
      };
    }
    if (dropdownState && dropdownState.dropdownOpen) {
      sessionStorage.setItem(EDITOR_DROPDOWN_KEY, JSON.stringify(dropdownState));
    } else if (!pinnedDesktopDropdownId) {
      sessionStorage.removeItem(EDITOR_DROPDOWN_KEY);
    }
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (!isDesignMode()) return;
    if (!getHeaderSectionRoot(event.target)) return;

    setTimeout(function() {
      syncEditorBlockTargets();
      restoreMobileDrawerState();
      restoreDesktopDropdownState();
    }, 80);
  });

  document.addEventListener('shopify:block:select', function(event) {
    if (!isDesignMode()) return;

    if (isMobileHeaderActive()) {
      var mobileBlockEl = event.target;
      if (!mobileBlockEl || !mobileBlockEl.closest) return;

      var drawer = document.getElementById('header-menu');
      if (!drawer || !drawer.contains(mobileBlockEl)) return;

      setTimeout(function() {
        revealHeaderBlockInDrawer(mobileBlockEl);
      }, 50);
      return;
    }

    if (!isDesktopHeaderActive()) return;

    setTimeout(function() {
      var blockEl = findHeaderBlockElement(event);
      if (!blockEl || blockEl.closest('.header__mobile')) return;
      revealHeaderBlockInDesktop(blockEl);
    }, 50);
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    if (!isDesignMode() || !isDesktopHeaderActive()) return;

    var blockEl = findHeaderBlockElement(event);
    if (!blockEl || blockEl.closest('.header__mobile')) return;

    var dropdownId = getDropdownIdForElement(blockEl);
    if (dropdownId && dropdownId === pinnedDesktopDropdownId) {
      clearDesktopDropdownState();
      if (desktopDropdownObserver) {
        desktopDropdownObserver.disconnect();
        desktopDropdownObserver = null;
      }
    }
  });

  document.addEventListener('shopify:section:deselect', function() {
    if (!isDesignMode()) return;
    clearDesktopDropdownState();
    if (desktopDropdownObserver) {
      desktopDropdownObserver.disconnect();
      desktopDropdownObserver = null;
    }
  });

  window.addEventListener('resize', function() {
    if (!isDesignMode()) return;
    syncEditorBlockTargets();
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
